import Header from './Header'
import Footer from './Footer'

interface LayoutProps {
  children: React.ReactNode
}

// 赛博朋克网格背景
function CyberGrid() {
  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
      {/* 主网格 */}
      <div 
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `
            linear-gradient(rgba(0, 240, 255, 0.5) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0, 240, 255, 0.5) 1px, transparent 1px)
          `,
          backgroundSize: '50px 50px',
        }}
      />
      
      {/* 次要网格 */}
      <div 
        className="absolute inset-0 opacity-[0.02]"
        style={{
          backgroundImage: `
            linear-gradient(rgba(157, 0, 255, 0.5) 1px, transparent 1px),
            linear-gradient(90deg, rgba(157, 0, 255, 0.5) 1px, transparent 1px)
          `,
          backgroundSize: '200px 200px',
        }}
      />
      
      {/* 径向渐变遮罩 */}
      <div 
        className="absolute inset-0"
        style={{
          background: 'radial-gradient(ellipse at center, transparent 0%, #0a0a0f 70%)',
        }}
      />
      
      {/* 扫描线效果 */}
      <div className="absolute inset-0 overflow-hidden">
        <div 
          className="absolute left-0 right-0 h-px bg-gradient-to-r from-transparent via-cyber-blue/30 to-transparent"
          style={{
            animation: 'scan-line 8s linear infinite',
          }}
        />
      </div>
      
      {/* 角落装饰 */}
      <div className="absolute top-20 left-4 w-20 h-20 border-l border-t border-cyber-blue/20 rounded-tl-lg" />
      <div className="absolute top-20 right-4 w-20 h-20 border-r border-t border-cyber-blue/20 rounded-tr-lg" />
      <div className="absolute bottom-20 left-4 w-20 h-20 border-l border-b border-cyber-blue/20 rounded-bl-lg" />
      <div className="absolute bottom-20 right-4 w-20 h-20 border-r border-b border-cyber-blue/20 rounded-br-lg" />
    </div>
  )
}

export default function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen bg-cyber-black flex flex-col relative">
      <CyberGrid />
      <Header />
      <main className="flex-1 relative z-10">
        {children}
      </main>
      <Footer />
    </div>
  )
}
